<template>
  <vx-card no-shadow :style="{ 'pointer-events': __isDisabledSites() ? 'none' : 'auto' }">

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="name" name="old_password" rules="" v-slot="{ errors }">
              <small class="label">2.1 Are all staff trained commensurate with their job?</small>
              <vs-switch v-model="form.is_staff_trained" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_staff_trained" vid="is_staff_trained_text" is_staff_trained_text="is_staff_trained_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please specify</small>
              <vs-input type="text" name="is_staff_trained_text" class="w-full" v-model="form.is_staff_trained_text" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_protective_clothing_available" name="is_protective_clothing_available" rules="" v-slot="{ errors }">
              <small class="label">2.2 Is suitable protective clothing available including hair nets?</small>
              <vs-switch v-model="form.is_protective_clothing_available" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_protective_clothing_available" vid="is_protective_clothing_available_text" is_staff_trained_text="is_protective_clothing_available_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please specify</small>
              <vs-input type="text" name="is_protective_clothing_available_text" class="w-full" v-model="form.is_protective_clothing_available_text" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>

            </ValidationProvider>
          </div>
        </div>

<!--        <vs-divider color="primary" border-style="dashed" class="mt-16" position="left">2.3</vs-divider>-->

        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="is_change_eating_available_text" name="staff_change_clothing" rules="required" v-slot="{ errors }">
              <small class="label">2.3 a. How frequently do staff change their clothing?</small>
<!--              <v-select name="staff_change_clothing" :closeOnSelect="true" v-model="form.staff_change_clothing" :options="['weekly', 'monthly', 'quarterly', 'half-yearly','yearly']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />-->
              <vs-input type="text" name="staff_change_clothing" class="w-full" v-model="form.staff_change_clothing" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_protective_clothing_laundered" name="is_protective_clothing_laundered" rules="" v-slot="{ errors }">
              <small class="label">2.3 b. Is protective clothing issued and laundered through external contractor?</small>
              <vs-switch v-model="form.is_protective_clothing_laundered" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_protective_clothing_laundered" vid="is_protective_clothing_laundered_text" is_staff_trained_text="is_protective_clothing_laundered_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please specify</small>
              <vs-input type="text" name="is_protective_clothing_laundered_text" class="w-full" v-model="form.is_protective_clothing_laundered_text" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_change_eating_available" name="is_change_eating_available" rules="" v-slot="{ errors }">
              <small class="label">2.4 Are separate changing and eating facilities available?</small>
              <vs-switch v-model="form.is_change_eating_available" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_change_eating_available" vid="is_protective_clothing_available_text" is_staff_trained_text="is_protective_clothing_available_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please specify</small>
              <vs-input type="text" name="is_protective_clothing_available_text" class="w-full" v-model="form.is_change_eating_available_text" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>


        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="ppe_worn" name="ppe_worn" rules="required" v-slot="{ errors }">
              <small class="label">2.5 Please give details of PPE worn on site, including type and colour</small>
              <vs-input type="text" name="ppe_worn" class="w-full" v-model="form.ppe_worn" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>

            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="personal_items" name="personal_items" rules="" v-slot="{ errors }">
              <small class="label">2.6 Do you have a jewellery and personal items policy?</small>
              <vs-switch v-model="form.personal_items" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.personal_items" vid="is_personal_items_text" name="is_personal_items_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please specify</small>
              <vs-input type="text" name="is_personal_items_text" class="w-full" v-model="form.is_personal_items_text" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

<!--        <vs-divider color="primary" border-style="dashed" class="mt-16" position="left">2.7 Do staff complete a medical questionnaire</vs-divider>-->
<!--        <p class="my-8">2.7 Do staff complete a medical questionnaire</p>-->
        <div class="vx-row mt-8 mb-4">
          <div class="vx-col md:w-full md:mb-0">
            <small>2.7 Do staff complete a medical questionnaire</small>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_medical_prior_employment" name="is_medical_prior_employment" rules="" v-slot="{ errors }">
              <small class="label">a. Prior to employment?</small>
              <vs-switch v-model="form.is_medical_prior_employment" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_medical_prior_employment" vid="is_medical_prior_employment_text" is_staff_trained_text="is_medical_prior_employment_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please specify</small>
              <vs-input type="text" name="is_medical_prior_employment_text" class="w-full" v-model="form.is_medical_prior_employment_text" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_medical_foreign_vacation" name="is_medical_foreign_vacation" rules="" v-slot="{ errors }">
              <small class="label">b. On return from foreign vacation?</small>
              <vs-switch v-model="form.is_medical_foreign_vacation" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_medical_foreign_vacation" vid="is_medical_foreign_vacation_text" is_staff_trained_text="is_medical_foreign_vacation_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please specify</small>
              <vs-input type="text" name="is_medical_foreign_vacation_text" class="w-full" v-model="form.is_medical_foreign_vacation_text" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>

            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_medical_absence" name="is_medical_absence" rules="" v-slot="{ errors }">
              <small class="label">c. Following absence?</small>
              <vs-switch v-model="form.is_medical_absence" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_medical_absence" vid="is_medical_absence_text" is_staff_trained_text="is_medical_absence_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please specify</small>
              <vs-input type="text" name="is_medical_absence_text" class="w-full" v-model="form.is_medical_absence_text" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>



        <div class="flex flex-wrap items-center justify-end" v-can="'edit-site'">
          <vs-button v-if="status.is_supplier_manufacture_site_employee_complete === 1"  button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4">Save and Change</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";


  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          is_staff_trained: false,
          is_protective_clothing_available: false,
          is_protective_clothing_laundered: false,
          is_change_eating_available: false,
          is_personal_items: false,
          is_medical_prior_employment: false,
          is_medical_foreign_vacation: false,
          is_medical_absence: false
        },
        id: null,
        status: {}
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    components: {
      'v-select': vSelect,
    },
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_supplier_manufacture_site_employee_complete === 1 ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data= (await SupplierManufactureRepository.UpdateManufactureEmployeeDetails(this.id, this.form))
          this.showSuccessMessage('Manufacture Employee Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          const data= (await SupplierManufactureRepository.CreateManufactureEmployeeDetails(this.form))
          this.showSuccessMessage('Manufacture Employee Details Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureEmployeeDetails(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureSiteStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_manufacture_site_id =  this.id
      await this.loadStatus()
      if (this.status.is_supplier_manufacture_site_employee_complete === 1 ) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
